import React from 'react'
import PlaylistSelector from './PlaylistSelector'
import EmptyState from '../EmptyState'
import PlaylistDisplay from './PlaylistDisplay'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRedux, withUser } from '../reduxContainer'
import {
  userFollowedPlaylists,
  getDisplayedPlaylist
} from '../../redux/selectors/playlists'
import {
  setDisplayedPlaylist,
  playlistDeleted,
  finishCreateNewPlaylist,
  clearPlaylistEntries,
  reorderUserPlaylists
} from '../../redux/actions/playlists'
import { currentUser } from '../../redux/selectors/user'

class UserPlaylists extends React.Component {
  constructor (props) {
    super(props)

    this.selectPlaylist = this.selectPlaylist.bind(this)
    this.removePlaylist = this.removePlaylist.bind(this)
    this.handleOnPlaylistAdded = this.handleOnPlaylistAdded.bind(this)
    this.setDisplayedPlaylistFromUUID = this.setDisplayedPlaylistFromUUID.bind(
      this
    )
    this.handleOnPlaylistDuplicated = this.handleOnPlaylistDuplicated.bind(this)

    // We use this.state.uuid to hold the current Playlist UUID that we should be rendering.
    // It is updated whenever the current implementation makes changes to the displayed playlist (e.g. selectPlaylist()).
    // This WOULD BE the ideal situation (have component maintain internal state), however, the component currently leverages Redux for this... for reasons(?)

    this.state = {
      uuid: this.props.uuid
    }

    window.onpopstate = e => {
      const uuid = e.state.uuid
      this.setDisplayedPlaylistFromUUID(uuid)
    }
  }

  // componentDidMount () {
  //   if (this.props.displayedPlaylist) {
  //     const playlist = this.props.displayedPlaylist
  //     window.history.replaceState(
  //       { uuid: playlist.uuid, active: this.props.playlistTab },
  //       null,
  //       `/user/playlists/${playlist.uuid}`
  //     )
  //   }
  // }

  componentDidUpdate () {
    const playlists = this.props.playlists
    if (!this.props.displayedPlaylist && playlists.length > 0) {
      const playlist = this.props.uuid
        ? playlists.filter(playlist => playlist.uuid === this.props.uuid)[0]
        : playlists[0]
      this.switchPlaylists(playlist)

      // window.history.replaceState(
      //   { uuid: playlist.uuid, active: this.props.playlistTab },
      //   null,
      //   `/user/playlists/${playlist.uuid}`
      // )
    }
  }

  handleOnPlaylistDuplicated (playlist) {
    this.props.clearPlaylistEntries()
    this.props.addDuplicatedPlaylist(playlist)

    this.switchPlaylist(this.props.playlists[0])
    //this.pushWindowState(playlist)
  }

  // pushWindowState (playlist) {
  //   window.history.pushState(
  //     { uuid: playlist.uuid, active: this.props.playlistTab },
  //     null,
  //     `/user/playlists/${playlist.uuid}`
  //   )
  // }

  setDisplayedPlaylistFromUUID (uuid) {
    const playlist = this.props.playlists.filter(
      playlist => playlist.uuid === uuid
    )[0]

    this.switchPlaylists(playlist)
  }

  handleOnPlaylistAdded (playlist) {
    this.setDisplayedPlaylistFromUUID(playlist.uuid)
    //this.pushWindowState(playlist)
  }

  selectPlaylist (playlist) {
    //const onMobile = window.innerWidth < 768

    // if (onMobile) {
    //   window.location.href = `/playlists/${playlist.uuid}`
    // } else {
      if (playlist.uuid !== this.state.uuid) {
        this.setState({ uuid: playlist.uuid })
        this.switchPlaylists(playlist)
      }
    //}
  }

  removePlaylist (uuid) {
    this.props.playlistDeleted(uuid)
    if (this.props.playlists.length > 0) {
      this.switchPlaylists(this.props.playlists[0])
    }
  }

  switchPlaylists (playlist) {
    this.props.clearPlaylistEntries()
    this.props.setDisplayedPlaylist(playlist)
  }

  render () {
    const {
      playlists,
      displayedPlaylist,
      currentUser,
      userLoaded,
      reorderUserPlaylists
    } = this.props

    let playlistDisplay
    
    if (currentUser) {
      // If current user is already loaded
      if (playlists.length === 0) {
        playlistDisplay = (
          <EmptyState
            caption="You haven't made or followed any playlists"
            link='/playlists'
            linkCaption='Explore our library'
          />
        )
      } else if (displayedPlaylist) {
        playlistDisplay = (
          <PlaylistDisplay
            playlist={displayedPlaylist}
            signedIn
            userIsAdmin={currentUser.isAdmin()}
            userIsAuthor={currentUser.isPlaylistAuthor(
              displayedPlaylist.author.username
            )}
            includePlaylistAddedDates={false}
            onDeleted={this.removePlaylist}
            onDuplicated={this.handleOnPlaylistDuplicated}
          />
        )
      }
    }

    return (
      <div className='UserPlaylists'>
        <div className='UserPlaylists__selector'>
          <PlaylistSelector
            playlists={playlists}
            onSelect={this.selectPlaylist}
            sortable
            isActive={playlist =>
              displayedPlaylist && playlist.uuid === displayedPlaylist.uuid
            }
            onPlaylistAdded={this.handleOnPlaylistAdded}
            loading={!userLoaded}
            onReordered={reorderUserPlaylists}
          />
        </div>
        <div className='UserPlaylists__display'>{playlistDisplay}</div>
      </div>
    )
  }
}

UserPlaylists.propTypes = {
  playlists: PropTypes.array,
  addDuplicatedPlaylist: PropTypes.func,
  uuid: PropTypes.string,
  playlistTab: PropTypes.number,
  displayedPlaylist: PropTypes.object,
  currentUser: PropTypes.object,
  userLoaded: PropTypes.bool,
  setDisplayedPlaylist: PropTypes.func,
  playlistDeleted: PropTypes.func,
  clearPlaylistEntries: PropTypes.func,
  reorderUserPlaylists: PropTypes.func
}

const mapStateToProps = state => {
  return {
    playlists: userFollowedPlaylists(state),
    displayedPlaylist: getDisplayedPlaylist(state),
    currentUser: currentUser(state),
    userLoaded: state.users.loaded
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setDisplayedPlaylist: playlist => {
      dispatch(setDisplayedPlaylist(playlist))
    },
    playlistDeleted: uuid => {
      dispatch(playlistDeleted(uuid))
    },
    addDuplicatedPlaylist: playlist => {
      dispatch(finishCreateNewPlaylist(playlist))
    },
    clearPlaylistEntries: () => {
      dispatch(clearPlaylistEntries())
    },
    reorderUserPlaylists: (order, sortable, e) => {
      dispatch(reorderUserPlaylists(order))
    }
  }
}

export default withRedux(
  withUser(connect(mapStateToProps, mapDispatchToProps)(UserPlaylists))
)
